import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ViewSidebarIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20H17C18.6543 20 20 18.6543 20 17V3C20 1.3457 18.6543 0 17 0H3C1.3457 0 0 1.3457 0 3V17C0 18.6543 1.3457 20 3 20ZM18 3C18 2.44824 17.5518 2 17 2H3C2.44824 2 2 2.44824 2 3V17C2 17.5518 2.44824 18 3 18H17C17.5518 18 18 17.5518 18 17V3Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M6 3.5H8L8 16.5H6L6 3.5Z",
    fill: "currentColor"
  }));
}